export const parameter = [
  {
    name: 'CORE_REGION',
    description: 'Core regions name.',
    type: 'string'
  },
  {
    name: 'REGION',
    description: 'Region name.',
    type: 'string'
  },
  {
    name: 'SUBREGION',
    description: 'Subregion name.',
    type: 'string'
  },
  {
    name: 'START_DATE',
    description: 'The first date you want to view data for.',
    type: 'date'
  },
  {
    name: 'END_DATE',
    description: 'The last date you want to view data for.',
    type: 'date'
  },
  {
    name: 'START_DATETIME',
    description: 'The start datetime you want to view data for.',
    type: 'datetime'
  },
  {
    name: 'END_DATETIME',
    description: 'The last datetime you want to view data for.',
    type: 'datetime'
  },
  {
    name: 'DATE',
    description: 'The exact date you want to view data for.',
    type: 'date'
  },
  {
    name: 'NUMBER_OF_PERIODS',
    description: 'Number of hours/days/weeks/months looking back from current time.',
    type: 'number'
  },
  {
    name: 'PRODUCT',
    description: 'Types of the product.',
    type: 'number',
    options: [
      'Lime-S',
      'Lime-E',
      'Pedal Bike',
      'Limepod',
      'All Products'
    ]
  },
  {
    name: 'SW_LATITUDE',
    description: 'Latitude for SW corner of area',
    type: 'decimal(10,6)'
  },
  {
    name: 'SW_LONGITUDE',
    description: 'Longitude for SW corner of area',
    type: 'decimal(10,6)'
  },
  {
    name: 'NE_LATITUDE',
    description: 'Latitude for NE corner of area',
    type: 'decimal(10,6)'
  },
  {
    name: 'NE_LONGITUDE',
    description: 'Longitude for NE corner of area',
    type: 'decimal(10,6)'
  },
  {
    name: 'AGGREGATE_LEVEL',
    description: 'Time period for metric aggregation',
    type: 'keyword',
    options: [
      'weekly',
      'daily',
      'hourly'
    ]
  },
  {
    name: 'NUMBER_OF_LIMIT',
    description: 'Restriction on number of lines to return in the results.',
    type: 'number',
    default: 10000,
    optional: true
  }
]

export const category = [
  'trips',
  'payments',
  'topline',
  'rider',
  'juicer',
  'decay',
  'fleet',
  'gr',
  'tasks',
  'customer experience',
  'other'
]
